import { useRecruitmentApi } from 'infrastructure/api';
import type { PositionFillRequest, PositionFillRequestFormValues, SubmitPositionFillRequestCommand } from './types';

const buildExpirationDate = (expirationPeriodInMonth: string) => {
  const date = new Date();

  date.setMonth(date.getMonth() + Number(expirationPeriodInMonth));

  return date.toISOString().slice(0, 10);
};

const mapPositionFillRequestFormToSubmitCommand = (
  values: PositionFillRequestFormValues,
  positionSlotId = values.positionSlotId,
): SubmitPositionFillRequestCommand => ({
  positionSlotId,
  expirationDate: buildExpirationDate(values.expirationPeriodInMonth),
  responsibilities: values.responsibilities,
  requiredExperience: Number(values.requiredExperience),
  englishLevel: values.englishLevel,
  requirements: values.requirements,
  projectName: values.projectName || undefined,
  projectDescription: values.projectDescription || undefined,
  notes: values.notes,
});

const useCreatePositionFillRequestService = () => {
  const { sendPostRequest } = useRecruitmentApi();

  const createPositionFillRequest = async (values: PositionFillRequestFormValues): Promise<PositionFillRequest[]> => {
    const positionSlotIds = [values.positionSlotId, ...values.matchingPositionSlotIds];

    const requests = positionSlotIds.map(positionSlotId =>
      mapPositionFillRequestFormToSubmitCommand(values, positionSlotId),
    );

    const response = await sendPostRequest('/position-fill-requests', requests);

    return response.json() as Promise<PositionFillRequest[]>;
  };

  return { createPositionFillRequest };
};

export default useCreatePositionFillRequestService;
